<template>
  <div v-if="notification_settings" class="secondary-c tw-text-lg">

    <p class="tw-font-bold tw-text-lg tw-text-gray-800 tw-mb-4" v-text="$t('profile.emails')" />
    <div class="tw-mb-6">
      <form-checkbox name="notify_new_inbox" :label="$t('profile.notify_new_inbox')" @input="onCheckboxInput"
                     :value="notification_settings.notify_new_inbox === '1' ? true : false"></form-checkbox>
    </div>
    <div class="tw-mb-6">
      <form-checkbox name="notify_mention" :label="$t('profile.notify_mention')" @input="onCheckboxInput"
                     :value="notification_settings.notify_mention === '1' ? true : false"></form-checkbox>
    </div>
      <div class="tw-mb-6">
          <form-checkbox name="notify_events" :label="$t('profile.notify_events')" @input="onCheckboxInput"
                         :value="notification_settings.notify_events === '1' ? true : false"></form-checkbox>
      </div>
      <div class="tw-mb-6">
          <form-checkbox name="notify_invites" :label="$t('profile.notify_invites')" @input="onCheckboxInput"
                         :value="notification_settings.notify_invites === '1' ? true : false"></form-checkbox>
      </div>
    <div class="tw-mb-6">
      <form-checkbox name="notify_digest" :label="$t('profile.receive_digest')" @input="onCheckboxInput"
                     :value="notification_settings.notify_digest === '1' ? true : false"></form-checkbox>
    </div>
    <div class="tw-mb-6">
      <form-checkbox name="notify_abandened_course" :label="$t('profile.notify_abandened_course')" @input="onCheckboxInput"
                     :value="notification_settings.notify_abandened_course === '1' ? true : false"></form-checkbox>
    </div>
    <div class="tw-mb-6">
      <form-checkbox name="notify_long_inactive" :label="$t('profile.notify_long_inactive')" @input="onCheckboxInput"
                     :value="notification_settings.notify_long_inactive === '1' ? true : false"></form-checkbox>
    </div>
    <p class="tw-font-bold tw-text-lg tw-text-gray-800 tw-mb-4 tw-mt-8" v-text="$t('profile.push_notifications')" />
    <div class="tw-mb-6">
      <form-checkbox name="push_inbox" :label="$t('profile.notify_new_inbox')" @input="onCheckboxInput"
                     :value="notification_settings.push_inbox === '1' ? true : false"></form-checkbox>
    </div>
      <div class="tw-mb-6">
          <form-checkbox name="push_mention" :label="$t('profile.notify_mention')" @input="onCheckboxInput"
                         :value="notification_settings.push_mention === '1' ? true : false"></form-checkbox>
      </div>
      <div class="tw-mb-6">
          <form-checkbox name="push_events" :label="$t('profile.notify_events')" @input="onCheckboxInput"
                         :value="notification_settings.push_events === '1' ? true : false"></form-checkbox>
      </div>
      <div class="tw-mb-6">
          <form-checkbox name="push_invites" :label="$t('profile.notify_invites')" @input="onCheckboxInput"
                         :value="notification_settings.push_invites === '1' ? true : false"></form-checkbox>
      </div>
      <div class="tw-mb-8">
          <form-checkbox name="push_comment" :label="$t('profile.new_comment')" @input="onCheckboxInput"
                         :value="notification_settings.push_comment === '1' ? true : false"></form-checkbox>
      </div>
      <div class="tw-mb-6">
          <form-checkbox name="push_abandened_course" :label="$t('profile.notify_abandened_course')" @input="onCheckboxInput"
                         :value="notification_settings.push_abandened_course === '1' ? true : false"></form-checkbox>
      </div>
      <div class="tw-mb-8">
          <form-checkbox name="push_long_inactive" :label="$t('profile.notify_long_inactive')" @input="onCheckboxInput"
                         :value="notification_settings.push_long_inactive === '1' ? true : false"></form-checkbox>
      </div>
    <div @click="saveSettings" class="general-button">{{ $t('fields.save') }}</div>
  </div>
</template>

<script>
import axios from 'axios';
import EditInput from '../EditInput.vue';
import Notification from '@/resources/assets/js/vue/lib/models/Notification';

export default {
  name: 'NotificationsTab',

  components: {
    'edit-input': EditInput,
  },
  props: ['settings'],
  data() {
    return {
      notification_settings: null
    }
  },
  methods: {
    onCheckboxInput(val, setting) {
      this.$set(this.notification_settings, setting, val ? "1" : "0");
    },
    saveSettings() {
      axios.post('/api/v3/profile/settings', { ...this.notification_settings }).then((response) => {
        Notification.insert({
          data: [
            {
              title: 'Notificaties opgeslagen!',
            },
          ],
        });
      });
    },
    getPrivacyPolicies() {
      axios.get('/api/v3/policies').then((response) => {
        this.policies = response.data;
      });
    },
    reduceSettings() {
      const reduced_settings = this.settings.settings.reduce((obj, setting) => {
        obj[setting.option] = setting.value === "1" ? "1" : "0";
        return obj;
      }, {});
      this.notification_settings = reduced_settings;
    }
  },
  mounted() {
    this.reduceSettings();
  }
}
</script>